import iconEdit from './edit.png';
import iconZwitsal from './zwitsal.png';
import iconPremium from './premium.png';

export const icons = { iconEdit, iconZwitsal, iconPremium };